<template>
  <div class="pb-20 related-products">
    <div class="flex items-center justify-between pb-4">
      <p class="text-xl font-medium">
        You May Also Like
      </p>
      <div class="flex">
        <div
          class="carousal-navs mr-2"
          @click="slideProduct(-1)"
        >
          <img src="@/assets/icons/chevronLeft.svg" class="mx-auto">
        </div>
        <div
          class="carousal-navs"
          @click="slideProduct(1)"
        >
          <img src="@/assets/icons/chevronRight.svg" class="mx-auto">
        </div>
      </div>
    </div>
    <div v-if="products.length">
      <ItemsCarousel
        :items="5"
        :dots="false"
        :margin="10"
        ref="carousel"
      >
        <div
          v-for="(product, index) in products"
          :key="`related-product-${index}`"
          class="p-1"
        >
          <ProductPreview :product="product" />
        </div>
      </ItemsCarousel>
    </div>
  </div>
</template>
<script>
import ItemsCarousel from '@/shared/components/shared/ItemsCarousel'
import ProductPreview from "@/shared/components/product/ProductPreview"

export default {
  name: 'RelatedProductsSection',
  components: {
    ItemsCarousel,
    ProductPreview
  },
  props: {
    products: {
      required: true
    }
  },
  methods: {
    slideProduct(val) {
      if (!this.$refs.carousel) return
      const navs = this.$refs.carousel.$el.querySelectorAll('.owl-nav')
      navs.forEach(nav => {
        val === 1 ? nav.lastChild.click() : nav.firstChild.click()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .related-products {
    .carousal-navs {
      @apply rounded-full border border-dark-b w-10 h-10 opacity-50 cursor-pointer flex items-center;
    }
  }
</style>